import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ExclamationIcon = ({ className, ...props }) => (
    <svg className={ classnames('otrl-icon__shadow', className) } xmlns="http://www.w3.org/2000/svg" id="svg1589" version="1.1" viewBox="0 0 74.4 74.64" width="120" height="120" { ...props }>
        <circle cx="35.8" cy="35.94" r="22.12" fill="currentColor"/>
        <path d="M35.08 39.54a1.32 1.32 0 01-.35-.82l-1-10.89v-.28a1.72 1.72 0 01.6-1.38 2.5 2.5 0 013 0 1.72 1.72 0 01.6 1.38v.31l-1 10.86a1.27 1.27 0 01-.35.82 1 1 0 01-.71.28 1 1 0 01-.79-.28zm-.77 5.55a2.19 2.19 0 010-3 2.14 2.14 0 013 0 2.19 2.19 0 010 3 2.11 2.11 0 01-3 0z" fill="#fff"/>
    </svg>

);

ExclamationIcon.propTypes = {
    className: PropTypes.string
};

ExclamationIcon.defaultProps = {
    className: ''
};

export default ExclamationIcon;
